import { TGetAllPlantCountByStatusParams } from '../utils/types/orderPendency';
import { emptySplitApi } from './emptySplitApi';

export const orderPendencyService =
  emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
      getAllPlantCountByStatus: builder.query<
        { data: void; totalCount: number },
        TGetAllPlantCountByStatusParams
      >({
        query: (params) => ({
          url: 'retailers/order/list',
          method: 'GET',
          params: {
            searchKey: '',
            sort: 'createdDate,desc',
            page: 0,
            size: 1,
            ...params,
          },
        }),
        transformResponse: (data: void, meta: Response) => {
          const totalCount =
            meta.headers.get('X-total-count');
          return {
            data,
            totalCount: Number(totalCount ? totalCount : 0),
          };
        },
      }),
    }),
  });

export const { useLazyGetAllPlantCountByStatusQuery } =
  orderPendencyService;
